import React from 'react'
import { array, func, any, string } from 'prop-types'
import BaseServiceFilter from './BaseServiceFilter'
import FilterButton from './buttons/FilterButton'
import { ReactComponent as TuneVariant } from '../assets/tune-variant.svg'
import { Box, Popover } from '@mui/material'

export default function BaseFilter({
  filter,
  components,
  onChange = () => {},
  color
}) {
  const [anchorElFilter, setAnchorElFilter] = React.useState(null)

  const handleOpenFilterMenu = event => {
    setAnchorElFilter(event.currentTarget)
  }
  const handleCloseFilterMenu = () => {
    setAnchorElFilter(null)
  }

  return (
    <Box sx={{ flexGrow: 0, display: 'flex', zIndex: '999' }}>
      <FilterButton
        className="filterButton"
        color={color}
        text="filtrar"
        bg="#000000BF"
        Icon={TuneVariant}
        onClick={handleOpenFilterMenu}
      />
      <Popover
        sx={{
          mt: '45px',
          minWidth: '340px',
          maxWidth: '380px',
          '& .MuiPaper-elevation': {
            overflowY: 'inherit',
            overflowX: 'inherit'
          }
        }}
        id="menu-appbar"
        anchorEl={anchorElFilter}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        open={Boolean(anchorElFilter)}
        onClose={handleCloseFilterMenu}
      >
        {filter?.map((item, index) => (
          <div
            style={{
              minWidth: '340px',
              padding: '.5rem 0.75rem'
            }}
            key={index}
            onClick={e => e.stopPropagation()}
          >
            <BaseServiceFilter
              filter={item}
              onChange={value => {
                onChange(value)
              }}
            />
          </div>
        ))}
        {components && (
          <div style={{ padding: '0.5rem 0.75rem' }}>{components}</div>
        )}
      </Popover>
    </Box>
  )
}

BaseFilter.propTypes = {
  filter: array,
  onChange: func,
  components: any,
  color: string
}
